import { getTabOperationCount } from './getTabItemsCount.helper';

import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getAppAndSiteMarketplaceTags(
  appSiteConfiguration: TargetingBaseType['appSiteConfiguration'],
  deals: TargetingBaseType['deals']
): TagItem[] {
  const includedCount =
    getTabOperationCount(appSiteConfiguration, 'generic', 'include') +
    getTabOperationCount(appSiteConfiguration, 'specific', 'include');
  const excludedCount =
    getTabOperationCount(appSiteConfiguration, 'generic', 'exclude') +
    getTabOperationCount(appSiteConfiguration, 'specific', 'exclude');
  const result: TagItem[] = [];
  if (includedCount > 0) {
    result.push({ label: `${includedCount} included site${includedCount !== 1 ? 's' : ''}` });
  }
  if (excludedCount > 0) {
    result.push({ label: `${excludedCount} excluded site${excludedCount !== 1 ? 's' : ''}` });
  }
  if (deals?.length > 0) {
    result.push({ label: `${deals.length} deal${deals.length !== 1 ? 's' : ''}` });
  }

  return result;
}
